module.exports = __webpack_public_path__ + "public/images/generated-learn-sign-language.12e05779abb050ff556a1b17c9f96440.jpg";